import { CoachModel } from '@modules/coach/coach-model';

const fields = new CoachModel().fields();

export default [
    fields.teams,
    fields.firstName,
    fields.lastName,
    fields.gender,
    fields.type,
    fields.country,
];